<template>
  <div>

    <!-- Footer -->
    <footer>
      <div class="container">
        <div class="footer-content mb-2">
          <div class="footer-logo">
            <div class="bg-title mb-2">SWAC</div>
            <div class="text text-uppercase">SouthWestern Accreditation Council </div>
          </div>
          <div class="footer-links">
            
            <router-link class="footer-link"
              v-if="(header[0]) ? header[0].status : false"
              to="/accreditations">Accreditation</router-link>

            <router-link class="footer-link"
              v-if="(header[8]) ? header[8].status : false"
              to="/our-certificates">Certification</router-link>

            <router-link class="footer-link"
              v-if="(header[3]) ? header[3].status : false"
              to="/about">About</router-link>

            <router-link class="footer-link"
              v-if="(header[1]) ? header[1].status : false"
              to="/programs">Programs</router-link>

            <router-link class="footer-link"
              v-if="(header[2]) ? header[2].status : false"
              to="/memberships">Membership</router-link>

            <router-link class="footer-link"
              v-if="(header[4]) ? header[4].status : false"
              to="/contact">Contact us</router-link>

            <router-link class="footer-link"
              v-if="(header[7]) ? header[7].status : false"
              to="/online-trainings">Online Training</router-link>

            <router-link class="footer-link"
              v-if="(header[6]) ? header[6].status : false"
              to="/events">Events & Conferences</router-link>

            <router-link v-for="(pg, idx) in pages" :key="idx"
                :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                class="footer-link"
                :class="(pg.has_footer) ? '' : 'hidden' ">
                {{ pg.title }}</router-link>

          </div>
        </div>
        <div class="footer-bottom d-flex justify-content-between">
          <div class="fb-text">2021 All Rights Reserved © SWAC SouthWestern Accreditation Council 
            <router-link class="ml-2"
                v-if="(header[5]) ? header[5].status : false"
                to="/privacy">Privacy Policy
            </router-link>
          </div>
          <div class="socialmedia d-flex align-items-center">
            <div class="follow-text mr-3">Follow us</div>
            <div class="footer-socialmedia">

              <a v-for="(social, index) in rows" 
                class="facebook-icon social-icon" 
                :href="social.provider_url"
                target="_blank"
                :key="index">
                <i v-if="social.provider.toLowerCase() == 'facebook'"
                  class="fab fa-facebook-f"></i>
                <i v-if="social.provider.toLowerCase() == 'youtube'"
                  class="fab fa-youtube"></i>
                <i v-if="social.provider.toLowerCase() == 'linkedin'"
                  class="fab fa-linkedin-in"></i>
                <i v-if="social.provider.toLowerCase() == 'twitter'"
                  class="fab fa-twitter"></i>
              </a>
              
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer -->


  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      rows: [],
      header: [],
      pages: [],
    };
  },
  created() {

      axios
      .get(window.baseURL + "/setting")
      .then((res) => {
        this.rows = res.data.social;
        this.header = res.data.header;
      })
      .catch(() => { });


      axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
      
  },
};
</script>
